export enum ProductHandlingMode {
	Default = 0,
	Recurring = 1,
	Charge = 2,
	Hide = 3,
	Show = 4
}
